"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { action, observable, computed } from "mobx";
export var FolderAnimationStates = /* @__PURE__ */function (FolderAnimationStates2) {
  FolderAnimationStates2["Visible"] = "visible";
  FolderAnimationStates2["Hidden"] = "hidden";
  return FolderAnimationStates2;
}(FolderAnimationStates || {});
export var FolderTreeViewStore = /*#__PURE__*/function () {
  function FolderTreeViewStore(getFoldersFunc, selectionStateProvider) {
    _classCallCheck(this, FolderTreeViewStore);
    this.getFoldersFunc = getFoldersFunc;
    this.selectionStateProvider = selectionStateProvider;
    this._treeState = /* @__PURE__ */new Map();
  }
  _createClass(FolderTreeViewStore, [{
    key: "folders",
    get: function get() {
      return this.getFoldersFunc();
    }
  }, {
    key: "isFolderToggledOpen",
    value: function isFolderToggledOpen(id) {
      var folderState = this._treeState.get(id);
      if (!!folderState) {
        return folderState.isToggledOpen;
      } else {
        return false;
      }
    }
  }, {
    key: "isFolderSelected",
    value: function isFolderSelected(id) {
      return id === this.selectedFolder;
    }
  }, {
    key: "onToggle",
    value: function onToggle(folderId) {
      var folderState = this.getOrCreateViewState(folderId);
      folderState.isToggledOpen = !folderState.isToggledOpen;
    }
  }, {
    key: "selectedFolder",
    get: function get() {
      return this.selectionStateProvider.selectedFolder;
    }
  }, {
    key: "getOrCreateViewState",
    value: function getOrCreateViewState(folderId) {
      if (!this._treeState.has(folderId)) {
        this._treeState.set(folderId, {
          isToggledOpen: false
        });
      }
      return this._treeState.get(folderId);
    }
  }]);
  return FolderTreeViewStore;
}();
__decorateClass([observable], FolderTreeViewStore.prototype, "_treeState", 2);
__decorateClass([action], FolderTreeViewStore.prototype, "onToggle", 1);
__decorateClass([computed], FolderTreeViewStore.prototype, "selectedFolder", 1);
__decorateClass([action], FolderTreeViewStore.prototype, "getOrCreateViewState", 1);